import client from './client';

/**
 * Mock Sessions API (Phase 4 - candidate self-practice)
 */

export const listMockSessions = () => {
  console.log('[mockSessions] list');
  return client.get('/api/mock-sessions');
};

export const listOrgMockSessions = () => {
  console.log('[mockSessions] listOrg');
  return client.get('/api/mock-sessions/admin/org');
};

export const getMockSession = (id) => {
  console.log('[mockSessions] get', id);
  return client.get(`/api/mock-sessions/${id}`);
};

export const listMockAnswers = (sessionId) => {
  console.log('[mockSessions] listAnswers', sessionId);
  return client.get(`/api/mock-sessions/${sessionId}/answers`);
};
